import { HostServices, Session } from '@ally/federated-types'
import { StatusTrackerActivity } from '@ally/shared-status-tracker'

type FetchParams = {
  guid: string
  session: Session
  featureFlags: HostServices['featureFlags']
}

export const fetchActivitiesData = async ({
  guid,
  session,
  featureFlags,
}: FetchParams): Promise<StatusTrackerActivity[]> => {
  const activitiesVersionNumber = featureFlags.variation(
    'FF_activities-version',
    0,
  )
  const activitiesVersionGreaterThanZero = activitiesVersionNumber > 0
  const activitiesVersionUrl = activitiesVersionGreaterThanZero
    ? `/v${activitiesVersionNumber}`
    : ''
  const endpointUrl = `/acs${activitiesVersionUrl}/customers/${guid}/activities`
  const CSRFChallengeToken = activitiesVersionGreaterThanZero
    ? null
    : session.data?.CSRFChallengeToken
  const bearerToken = activitiesVersionGreaterThanZero
    ? session.data?.access_token
    : session.data?.AwsAccessToken ||
      (sessionStorage &&
        JSON.parse(sessionStorage.getItem('AwsAccessToken') || 'null'))
  const patronID = activitiesVersionGreaterThanZero ? null : 'olbWeb'

  return fetch(endpointUrl, {
    method: 'GET',
    headers: {
      ...(CSRFChallengeToken && { CSRFChallengeToken }),
      Authorization: `Bearer ${bearerToken}`,
      ...(patronID && { 'patron-id': patronID }),
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json, text/javascript, */*; q=0.01',
    } as HeadersInit,
  })
    .then(response => response.json().then(activities => activities))
    .catch(error => console.log('FETCH ACTIVITIES ERROR:', error))
}
